"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeQuickQuoteAddressWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var React = require("react");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualHomeQuickQuoteAddressWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeQuickQuoteAddressWidget, _super);
    function AnnualHomeQuickQuoteAddressWidget(props) {
        return _super.call(this, props) || this;
    }
    AnnualHomeQuickQuoteAddressWidget.prototype.render = function () {
        var address = (0, commonFunctions_1.getAddressLine1WithPostcode)(this.props.interaction.realEstate[0].address);
        return (React.createElement("div", { className: "section-panel annual-home-mta page-contents-inner mt-0" },
            React.createElement("div", { className: "section" },
                React.createElement("img", { className: "home-image grid-row-1-2", src: "/Allianz/img/home-icon.png", alt: "Home icon" }),
                React.createElement("div", { className: "mb-0 section-heading" },
                    React.createElement("span", null, "Insured address"),
                    this.renderInfoModal()),
                React.createElement("div", null, address))));
    };
    AnnualHomeQuickQuoteAddressWidget.prototype.renderInfoModal = function () {
        return (React.createElement(InfoModal_1.InfoModal, { title: "Insured address", className: "d-inline align-middle" },
            React.createElement("p", null, "All policies under the same account need to have the same property address. If you wish to insure a different property than the one listed below please get a quote with a different email address.")));
    };
    return AnnualHomeQuickQuoteAddressWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeQuickQuoteAddressWidget = AnnualHomeQuickQuoteAddressWidget;
//# sourceMappingURL=AnnualHomeQuickQuoteAddressWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/AnnualHomeQuickQuoteAddressWidget.js
// module id = 3718
// module chunks = 0